/* eslint-disable camelcase */
import SearchTypes from '@/domain/SearchTypes'
import { DateFactory } from 'rhg-vue-common'

export function checkDate (checkInDate, checkOutDate) {
  const regexDate = /^\d{4}-\d{1,2}-\d{1,2}$/

  if (!checkInDate || !checkOutDate) {
    return false
  }

  if (!regexDate.test(checkInDate) || !regexDate.test(checkOutDate)) {
    return false
  }

  checkInDate = DateFactory.dateFromPattern(checkInDate)
  checkOutDate = DateFactory.dateFromPattern(checkOutDate)
  const now = DateFactory.now()

  return !!(checkInDate >= DateFactory.subtractDays(now, 2) && checkOutDate > checkInDate)
}

function checkSearchType (searchtype) {
  return !!(searchtype && Object.keys(SearchTypes).find((type) => SearchTypes[type] === searchtype))
}

function checkOccupancies (adults, children) {
  return !!(adults && children && adults.every(nbOfAdult => nbOfAdult > 0))
}

function checkPromotionCode (searchType, promotionCode) {
  return !!(searchType !== SearchTypes.PAC || (searchType === SearchTypes.PAC && promotionCode))
}

export default ({
  checkInDate,
  checkOutDate,
  startDate,
  day_of_week,
  adults,
  children,
  searchType,
  hotelCode,
  promotionCode
}) => {
  const isFlexibleDatesSearch = !!(startDate || day_of_week)

  return !!hotelCode && (isFlexibleDatesSearch || checkDate(checkInDate, checkOutDate)) &&
      checkOccupancies(adults, children) &&
      checkSearchType(searchType) &&
      checkPromotionCode(searchType, promotionCode)
}
